
import Vue from 'vue'
import ProjectMixin from '@/_mixins/project'

import { PSI } from '@/views/Project/PSI/types/psi'
import { serialise } from 'kitsu-core'
import { deleteRequest } from '@/plugins/api-axios'

import PsiSettingsDialog from '@/views/Project/PSI/dialogs/settings/psi.vue'
import ConfirmationDialog from '@/views/Project/Form/dialogs/confirmation.vue'
import LogPsi from '@/views/Project/PSI/dialogs/log.vue'

const PsiCardSettings = Vue.extend({
    mixins: [ProjectMixin],
    components: {},
    props: {
        value: {
            type: null || Object,
            required: true,
        },
        revisions: {
            type: Array,
            default: () => [],
        },
        handleRevisionChanged: {
            type: Function,
        },
        refreshFormRevisions: {
            type: Function,
        },
        addRevision: {
            type: Function,
        },
        viewRevision: {
            type: Function,
        },
        project: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loadingMenu: false,
            loadingActivate: false,
            viewMore: false,
            psi: this.value as PSI,
            revision: {} as any,
        }
    },

    computed: {
        visibleRevisions() {
            return this.viewMore
                ? this.revisions
                : this.revisions.slice(0, this.visibleRevisionCount)
        },
        visibleRevisionCount() {
            let count = this.revisions.find((revision) => revision._status === 'active') ? 1 : 0
            if (this.revisions.find((revision) => revision._status === 'draft')) count++
            if (count === 0 && this.revisions.length > 0) count++
            return count
        },
    },

    watch: {
        psi: {
            immediate: false,
            deep: true,
            async handler() {
                this.handleInput()
            },
        },
    },

    methods: {
        handleInput() {
            this.$emit('input', this.psi)
        },
        async editPSI(psi: PSI) {
            let res: any = await this.openDialog(PsiSettingsDialog, { psi, project: this.project })
            if (res) {
                this.psi = res
            }
        },
        async toggleIsArchived() {
            this.loadingMenu = true
            let payload = serialise(this.psi.type, {
                id: this.psi.id,
                isArchived: !this.psi.isArchived,
            })

            let res = await this.patch(this.psi.links.self, this.headersmixins, payload)

            if (res && res.type) {
                this.psi = res
            }

            this.loadingMenu = false
        },
        async deletePSI(psi: PSI) {
            this.loadingMenu = true
            await deleteRequest(psi.links.self, this.headersmixins)
            this.$emit('deletePSI', this.psi.id)
            this.loadingMenu = false
        },
        async viewLog() {
            await this.openDialog(LogPsi, { psi: this.psi })
        },

        async activateRevision(revision) {
            this.loadingActivate = true
            await this.handleRevisionChanged({
                revision,
                autoActivate: true,
                resourceId: this.psi.id,
            })
            this.loadingActivate = false
        },

        async deleteRevision(revision) {
            let ok = await this.openDialog(ConfirmationDialog, {
                message: this.$t('form_fe["revision.text_deleteRevisionConfirmation"]'),
                title: this.$t('form_fe["revision.heading_deleteRevision"]'),
            })

            if (!ok) return

            await deleteRequest(
                this.getURL({
                    path: `formRevisions/${revision.id}`,
                    base: this.formBaseUrl,
                }),
                this.getRequestHeaders('DELETE')
            )

            await this.refreshFormRevisions(this.psi.id)
        },

        getRevisionTitles(title: Record<string, string>) {
            let titles = ''
            Object.keys(title).forEach((language, index, array) => {
                titles += title[language] + (index === array.length - 1 ? '' : '\n')
            })
            return titles
        },
    },
})

export default PsiCardSettings
